/* Based on
 * - EGM Mathematical Finance class by Enrique Garcia M. <egarcia@egm.co>
 * - A Guide to the PMT, FV, IPMT and PPMT Functions by Kevin (aka MWVisa1)
 */

var ExcelFormulas = {

	PMT: function(rate, nper, pv, fv, type) {
		if (!fv) fv = 0;
		if (!type) type = 0;

		if (rate === 0) return -(pv + fv)/nper;

		var pvif = Math.pow(1 + rate, nper);
		var pmt = rate / (pvif - 1) * -(pv * pvif + fv);

		if (type === 1) {
			pmt /= (1 + rate);
		};

		return pmt;
	},

	IPMT: function(pv, pmt, rate, per) {
		var tmp = Math.pow(1 + rate, per);
		return 0 - (pv * tmp * rate + pmt * (tmp - 1));
	},

	PPMT: function(rate, per, nper, pv, monthlyInterest, fv, type) {
		if (per < 1 || (per >= nper + 1)) return null;
		var pmt = this.PMT(rate, nper, pv, fv, type);
		var ipmt = (monthlyInterest === undefined || monthlyInterest === null) ? this.IPMT(pv, pmt, rate, per - 1) : monthlyInterest;
		return pmt - ipmt;
	}

};

export default ExcelFormulas;
